var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2442 4383 c-2 -64 -5 -120 -8 -125 -3 -4 5 -8 18 -8 23 0 23 1 23 125 0 105 -2 125 -15 125 -13 0 -16 -20 -18 -117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2258 4481 c7 -4 17 -21 22 -37 8 -28 8 -28 7 8 -2 31 -6 38 -22 38 -14 0 -16 -3 -7 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2569 4481 c7 -5 17 -15 22 -22 6 -10 9 -8 9 9 0 16 -6 22 -22 22 -17 0 -19 -3 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098 4459 c6 -7 13 -27 13 -43 2 -26 2 -27 6 -7 4 22 13 16 99 -70 73 -72 94 -89 94 -73 0 27 -172 198 -203 202 -18 3 -20 1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919 4423 c-2 -10 -2 -10 27 -116 13 -49 24 -96 24 -106 0 -14 6 -17 25 -14 22 5 23 7 11 27 -8 11 -24 65 -37 118 -15 59 -29 98 -36 98 -7 0 -14 -3 -14 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2939 4405 c-76 -41 -87 -157 -19 -205 38 -27 49 -25 22 3 -53 56 -49 143 9 191 34 29 28 33 -12 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3082 4381 c26 -33 38 -38 38 -17 0 15 -36 46 -53 46 -5 0 2 -13 15 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2560 4390 c-13 -9 -13 -11 0 -20 15 -10 25 0 18 20 -2 6 -8 6 -18 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 4370 c-13 -8 -13 -10 2 -10 9 0 24 -3 32 -6 12 -5 15 -2 10 10 -7 18 -22 20 -44 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2292 4360 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701 4350 c-13 -7 -8 -26 27 -115 23 -59 40 -111 37 -116 -8 -12 2 -11 26 2 14 7 17 14 11 22 -11 12 -70 155 -81 194 -4 16 -10 20 -20 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121 4334 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632 4321 c-8 -5 -12 -17 -10 -27 2 -15 5 -13 15 9 14 30 14 30 -5 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3280 4246 l-44 -51 43 40 43 40 -5 -117 c-3 -65 -4 -118 -2 -118 2 0 9 -2 17 -5 10 -4 14 23 16 130 4 157 1 161 -68 81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2131 4253 c-1 -24 3 -33 15 -33 12 0 14 3 6 13 -5 6 -12 21 -15 32 -3 13 -5 9 -6 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2576 4265 c-19 -15 -19 -15 2 -15 13 0 22 6 22 15 0 18 0 18 -24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455 4235 c-29 -14 -29 -14 -3 -9 14 3 36 1 47 -6 23 -12 28 -1 9 18 -15 15 -16 15 -53 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3065 4200 c-4 -6 -17 -15 -29 -20 -20 -8 -19 -9 5 -9 16 -1 29 6 33 15 8 20 1 30 -9 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 4175 c-7 -61 13 -75 107 -75 69 0 73 -1 87 -27 15 -27 15 -27 16 -5 1 53 -15 62 -99 62 -81 0 -94 6 -104 45 l-5 20 -2 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2978 4173 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3532 4125 c-19 -31 -49 -76 -68 -101 -33 -43 -34 -47 -17 -59 15 -12 19 -11 22 3 2 9 30 56 63 104 53 75 65 109 40 108 -4 0 -22 -25 -40 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3618 4138 c47 -51 13 -114 -49 -91 -31 12 -31 12 -14 -7 16 -17 16 -26 7 -75 -11 -54 -8 -85 8 -85 10 0 24 125 16 139 -4 6 9 11 30 13 66 5 72 64 12 107 l-33 24 23 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3157 4136 c-14 -11 -15 -15 -3 -19 8 -3 16 2 19 14 3 10 4 19 4 19 -1 0 -10 -7 -20 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226 4091 c-3 -4 6 -13 19 -19 23 -11 24 -10 13 8 -14 22 -24 25 -32 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561 4020 c-13 -11 -19 -20 -14 -20 6 0 18 9 28 20 23 25 17 25 -14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 3999 c7 -12 17 -18 27 -15 8 3 22 6 31 6 13 1 -51 29 -66 30 -1 0 2 -9 8 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096 3984 c-11 -8 -15 -14 -8 -14 6 0 35 -29 63 -64 28 -36 64 -70 79 -76 32 -13 74 -5 92 18 10 14 10 15 -2 5 -20 -18 -64 -16 -88 5 -14 12 -93 106 -116 139 0 1 -10 -5 -20 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3851 3927 c-6 -8 -8 -16 -6 -19 3 -3 -12 -51 -33 -106 -31 -79 -37 -104 -27 -112 11 -9 36 49 103 238 6 16 -23 16 -37 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346 3883 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969 3864 c-15 -14 -11 -21 55 -81 39 -36 81 -76 94 -90 17 -19 22 -21 22 -7 0 9 -33 51 -74 93 -40 42 -75 82 -77 89 -3 9 -8 9 -20 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3661 3836 c-13 -7 -20 -15 -15 -18 5 -3 18 3 28 13 23 22 20 23 -13 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117 3633 c-4 -3 -7 -13 -7 -21 0 -12 3 -12 15 -2 8 7 15 16 15 21 0 11 -14 12 -23 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 3504 c-5 -14 -4 -15 9 -4 12 10 22 8 55 -9 38 -20 40 -20 31 -2 -18 34 -84 44 -95 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 3488 c-23 -30 -26 -43 -6 -25 11 9 27 17 37 17 9 0 14 5 11 10 -9 14 -31 13 -42 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915 3434 c-28 -19 -132 -44 -180 -44 -42 0 -69 14 -78 40 -4 10 -6 9 -6 -6 -1 -11 5 -29 13 -40 30 -40 241 -11 267 37 14 26 9 30 -16 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848 3320 c-13 -22 -24 -30 -46 -30 -30 0 -56 16 -65 40 -5 13 -6 12 -6 -1 -1 -9 9 -28 20 -43 16 -21 29 -26 52 -24 33 3 71 45 65 72 -2 12 -8 8 -20 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4246 3187 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 3082 c-8 -9 -6 -24 3 -18 5 3 28 -14 51 -38 24 -24 39 -46 34 -49 -4 -3 -36 -11 -71 -18 -45 -10 -62 -17 -62 -29 0 -15 6 -15 72 2 72 18 132 13 165 -14 9 -7 15 -5 19 8 4 11 9 23 12 28 3 5 0 6 -6 2 -6 -3 -31 -1 -57 6 -35 9 -59 26 -100 69 -30 31 -57 54 -60 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4110 2910 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4190 2886 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4332 2850 c-18 -17 -29 -30 -24 -30 5 0 21 14 37 30 37 38 30 38 -13 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4227 2841 c6 -7 9 -20 6 -29 -5 -11 -3 -13 8 -6 8 4 23 8 34 7 16 -1 16 -1 3 3 -10 3 -18 10 -18 16 0 6 -3 8 -7 5 -3 -4 -13 -1 -22 5 -13 10 -14 10 -4 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4546 2793 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 2772 c-7 -20 -4 -21 23 -7 22 12 22 13 3 18 -12 3 -22 -1 -26 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4349 2773 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498 2763 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 2752 c19 -6 5 -17 -87 -70 -61 -35 -110 -70 -110 -78 0 -18 14 -12 156 71 113 66 117 70 89 76 -16 4 -39 7 -50 7 -18 0 -17 -1 2 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4240 2690 c-3 -36 -2 -99 1 -140 4 -53 6 -62 7 -29 1 25 8 51 15 58 9 10 9 12 0 7 -9 -5 -13 16 -15 81 l-3 88 -5 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4504 2728 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4444 2718 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4372 2705 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4190 2686 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4338 2658 c-4 -24 -3 -26 13 -18 24 13 38 35 16 27 -9 -3 -18 -1 -20 6 -2 7 -6 0 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3920 2656 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4010 2595 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25 -28 25 -3 0 5 -11 18 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 2593 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 2586 c-9 -10 -8 -15 4 -20 10 -4 15 1 15 14 0 24 -4 25 -19 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 2583 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4494 2498 l-19 -23 25 20 c14 11 27 21 29 22 2 2 0 3 -6 3 -5 0 -18 -10 -29 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4687 2482 c-20 -22 -21 -32 -5 -32 6 0 8 3 5 7 -4 3 0 15 10 25 9 10 14 18 11 18 -3 0 -12 -8 -21 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 2434 c-37 -19 -58 -64 -57 -116 l2 -43 7 44 c5 31 15 51 35 67 39 31 106 47 141 34 38 -15 42 -5 5 14 -37 20 -97 20 -133 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4274 2418 l-29 -33 33 29 c30 28 37 36 29 36 -2 0 -16 -15 -33 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4065 2420 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23 20 -3 0 3 -9 13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4521 2414 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4619 2413 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4230 2356 c0 -27 2 -47 4 -45 10 10 13 67 5 80 -6 9 -9 -3 -9 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4585 2390 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4005 2385 c24 -8 114 -11 109 -3 -3 4 -31 8 -62 7 -31 0 -52 -2 -47 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4491 2374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4685 2380 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4552 2371 c-11 -6 -10 -10 4 -15 9 -3 19 -4 22 -1 3 3 0 5 -7 5 -7 0 -9 5 -6 10 7 12 4 12 -13 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 2344 c-1 -37 -31 -79 -71 -99 -35 -18 -111 -20 -128 -3 -6 6 -14 9 -17 6 -15 -14 53 -43 102 -43 44 0 56 5 82 29 32 30 46 75 38 117 -3 20 -5 19 -6 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3930 2366 c0 -2 7 -9 15 -16 13 -11 14 -10 9 4 -5 14 -24 23 -24 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4490 2339 c-24 -19 -24 -20 -2 -9 18 9 27 8 40 -2 15 -11 15 -11 5 3 -7 9 -10 19 -6 22 16 16 -14 5 -37 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4219 2240 c-7 -35 -4 -48 7 -38 3 4 4 21 2 40 l-3 33 -6 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3909 2203 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4233 2191 c-15 -13 -23 -29 -22 -48 2 -27 2 -27 6 -3 3 14 14 35 26 48 25 27 20 28 -10 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3952 2170 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3560 2139 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3590 2136 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3760 2116 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3871 2108 c-2 -30 11 -48 33 -47 20 0 20 1 1 8 -11 4 -23 19 -26 32 -4 14 -7 17 -8 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4349 2103 l33 -4 -28 -32 c-28 -31 -27 -30 9 2 20 19 37 36 37 38 0 2 -19 2 -42 1 -39 -1 -40 -2 -9 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 2091 c-7 -5 -60 -19 -118 -32 -81 -18 -103 -26 -100 -38 2 -9 10 -14 18 -12 104 27 213 50 220 45 10 -6 11 3 1 28 -5 12 -12 14 -21 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4202 2080 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4274 2084 c-18 -14 -18 -14 6 -3 31 14 36 19 24 19 -6 0 -19 -7 -30 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3770 2010 c0 -22 3 -40 8 -40 4 0 6 18 4 40 -2 22 -6 40 -8 40 -2 0 -4 -18 -4 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4051 2024 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4186 2005 c-4 -20 -6 -39 -4 -41 8 -8 25 55 18 66 -4 7 -10 -3 -14 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3648 1983 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4228 1973 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4157 1933 c-7 -37 8 -53 17 -17 4 15 3 31 -2 36 -6 6 -12 -2 -15 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3929 1933 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070 1946 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 1931 c-8 -5 -61 -19 -117 -32 -88 -19 -103 -25 -103 -42 0 -14 4 -17 18 -12 34 15 207 55 218 51 7 -3 9 5 6 20 -2 13 -5 24 -6 24 0 0 -8 -4 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3700 1936 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3852 1905 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4151 1864 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4553 1833 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4208 1823 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4290 1809 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4122 1780 c-14 -39 -13 -43 9 -21 11 10 14 23 9 35 -6 17 -8 15 -18 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3700 1776 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3836 1772 c-3 -5 1 -15 9 -22 8 -7 12 -17 8 -23 -3 -6 -1 -7 5 -3 7 4 12 1 12 -8 0 -8 4 -18 10 -21 7 -4 6 3 0 20 -15 39 -37 68 -44 57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3952 1760 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4158 1753 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4446 1752 c-2 -4 14 -8 37 -10 47 -3 47 2 0 11 -18 4 -34 3 -37 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 1731 c-6 -5 -56 -28 -111 -51 -88 -36 -101 -44 -96 -62 2 -11 8 -15 11 -10 3 5 53 29 111 53 58 23 107 44 108 45 2 1 0 10 -5 18 -5 10 -13 13 -18 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4388 1733 c-9 -2 -19 -10 -22 -18 -4 -12 -1 -12 19 -3 14 6 25 15 25 20 0 4 -1 7 -2 7 -2 -1 -10 -3 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4096 1715 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517 1713 c-3 -5 -1 -17 4 -28 4 -11 8 -15 8 -8 1 6 4 18 7 27 6 16 -11 23 -19 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3990 1675 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25 -28 25 -3 0 5 -11 18 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4320 1683 c0 -7 16 -25 35 -40 19 -15 35 -37 36 -48 l0 -20 8 20 c6 16 1 25 -25 43 -18 12 -38 30 -43 40 -6 9 -11 12 -11 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4060 1668 c0 -9 -8 -19 -17 -21 -17 -4 -17 -5 0 -6 9 0 17 -7 17 -13 1 -7 8 0 16 15 9 16 13 31 10 35 -3 3 -6 -1 -6 -9 0 -11 -2 -11 -10 1 -8 13 -10 13 -10 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3505 1620 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23 20 -3 0 3 -9 13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4488 1633 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4183 1623 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4550 1616 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4478 1593 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3665 1580 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3912 1565 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3785 1571 c-3 -5 0 -13 6 -17 7 -4 9 -3 5 4 -3 5 0 13 6 15 9 4 10 6 1 6 -6 1 -14 -3 -18 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 1562 c0 -15 11 -21 27 -15 12 5 12 7 1 14 -17 11 -28 11 -28 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3682 1540 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4364 1548 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3480 1556 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4503 1553 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4000 1511 c-11 -23 -19 -41 -16 -41 7 0 47 72 42 77 -2 3 -14 -13 -26 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831 1531 c-8 -5 -16 -15 -17 -23 -1 -7 -20 -61 -43 -119 -25 -63 -39 -113 -35 -124 7 -16 8 -16 18 1 5 11 11 24 12 29 2 10 34 95 73 193 21 52 19 60 -8 43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3526 1509 c-16 -16 -17 -19 -4 -19 9 0 19 7 22 16 9 24 4 24 -18 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3922 1490 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4227 1489 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3960 1440 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3 0 -10 -9 -16 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 1440 c-3 -5 -15 -10 -26 -10 -19 0 -26 -15 -10 -24 4 -3 19 6 31 19 13 14 21 25 17 25 -3 0 -9 -4 -12 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3570 1430 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20 -2 0 0 -9 6 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3921 1410 c0 -20 -12 -52 -26 -72 -22 -32 -22 -35 -5 -31 11 3 16 11 13 19 -3 9 0 14 8 12 7 -2 13 4 14 12 0 8 6 26 14 39 7 13 8 21 3 17 -6 -3 -13 4 -15 16 -3 16 -5 11 -6 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3610 1413 c0 -10 4 -14 8 -8 4 6 11 13 16 18 5 4 2 7 -7 7 -10 0 -17 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923 1390 c-10 -15 -9 -17 8 -13 20 5 25 18 11 27 -4 2 -13 -4 -19 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3736 1393 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3590 1395 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25 -5 8 -10 11 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3780 1390 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3632 1350 c-13 -11 -22 -24 -20 -28 1 -5 13 4 26 20 27 33 26 35 -6 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3824 1286 c0 -23 -5 -41 -12 -44 -7 -2 -10 -7 -7 -12 6 -9 -121 -155 -194 -224 -29 -26 -50 -50 -48 -52 6 -7 205 204 261 277 28 35 40 56 29 46 -22 -19 -22 -19 -26 15 -3 29 -4 29 -3 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4083 1315 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3679 1293 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947 1187 c-32 -66 -56 -122 -53 -124 8 -8 46 8 41 17 -5 8 27 83 41 99 2 2 12 -2 21 -10 17 -13 17 -13 1 6 -16 20 -16 23 8 65 20 35 22 46 12 55 -10 10 -24 -11 -71 -108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3468 1303 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3762 1290 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3978 1273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3628 1263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2950 1237 c0 -2 15 -16 33 -33 l32 -29 -29 33 c-28 30 -36 37 -36 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3605 1194 c3 -47 15 -56 15 -11 0 20 -4 38 -8 41 -5 3 -8 -11 -7 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115 1144 c-20 -15 -12 -17 19 -5 11 4 15 10 10 13 -5 4 -18 0 -29 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3989 1143 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2982 1120 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3102 1095 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3239 1103 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3973 1088 c1 -16 5 -28 9 -28 10 0 9 9 -2 35 -8 17 -8 16 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2992 1050 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3019 1053 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3172 1045 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3284 1038 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3203 1024 c-9 -20 -9 -23 1 -15 6 6 21 9 32 7 10 -2 13 -1 6 1 -11 4 -11 8 0 21 11 15 11 15 -4 4 -10 -8 -17 -9 -20 -3 -1 6 -8 -1 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3819 1023 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3746 1013 c2 -8 -16 -13 -54 -16 -31 -2 -12 -3 43 -3 55 -1 83 1 62 3 -24 3 -35 8 -31 15 4 6 3 8 -4 4 -5 -3 -12 -3 -15 1 -2 5 -2 3 -1 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4013 1023 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3156 988 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4144 992 c3 -5 0 -13 -6 -15 -9 -4 -10 -6 -1 -6 17 -1 25 16 12 25 -7 4 -9 3 -5 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306 983 c-11 -11 -6 -25 7 -20 6 2 20 0 31 -5 13 -7 16 -7 12 1 -10 16 -42 31 -50 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3900 986 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0 -20 -2 -20 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4033 983 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3119 953 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3514 918 c-16 -18 -22 -27 -13 -20 9 6 18 11 20 9 2 -1 3 0 1 2 -1 2 5 13 15 23 9 10 14 18 11 18 -2 0 -17 -14 -34 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3442 910 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4028 933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 923 c7 -11 -90 -156 -124 -185 -20 -17 -20 -17 0 -28 17 -8 22 -6 32 12 19 35 117 166 128 170 5 1 -2 12 -17 22 -14 11 -22 15 -19 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3054 913 c16 -20 36 -23 36 -6 0 4 -3 3 -7 0 -3 -4 -16 1 -27 10 -21 18 -21 18 -2 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3351 884 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3402 875 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3425 848 c-27 -22 -84 -63 -125 -91 -80 -53 -111 -78 -70 -56 14 7 33 12 44 10 10 -1 15 2 12 7 -8 14 13 27 42 25 19 -1 19 0 2 4 -16 3 -4 16 59 63 66 49 102 81 89 80 -2 -1 -25 -19 -53 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3675 871 c3 -5 -3 -12 -12 -14 -11 -3 -6 -5 11 -6 24 -1 27 1 16 14 -14 16 -25 21 -15 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3153 853 c24 -3 35 -8 31 -15 -4 -7 -2 -8 5 -4 20 13 1 26 -37 24 l-37 -1 38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 817 c0 -18 -3 -81 -8 -141 -7 -89 -6 -108 5 -104 10 3 16 33 21 94 4 49 9 106 12 127 3 28 0 40 -13 47 -15 7 -17 4 -17 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3074 828 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3064 786 c-18 -14 -18 -15 9 -21 15 -4 31 -5 34 -1 4 3 -4 6 -17 6 -19 0 -20 2 -10 15 16 19 10 19 -16 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695 739 c-11 -17 1 -21 15 -4 8 9 8 15 2 15 -6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 695 c-7 -8 -17 -12 -23 -8 -6 4 -7 1 -3 -6 6 -9 13 -8 27 5 10 9 19 19 19 21 0 7 -8 2 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3174 674 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876 672 c-2 -4 -2 -62 1 -129 5 -108 8 -122 25 -126 14 -4 18 -1 14 11 -3 9 -8 70 -12 135 -6 105 -13 133 -28 109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3075 623 c-38 -20 -64 -38 -56 -41 7 -2 16 0 20 5 3 6 30 22 59 37 28 14 52 29 52 31 0 7 3 8 -75 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574 628 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829 613 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3508 603 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789 563 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3543 573 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2932 556 c-17 -7 -38 -18 -45 -25 -10 -12 -9 -13 7 -7 12 4 23 1 28 -6 6 -10 8 -9 8 2 0 9 12 23 28 32 31 20 22 21 -26 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3246 561 c-3 -5 1 -11 9 -15 8 -3 17 0 21 6 4 6 24 8 53 4 32 -4 41 -3 31 4 -19 12 -107 13 -114 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3429 543 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3231 524 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732 500 c-14 -12 -18 -21 -12 -25 6 -4 12 -5 13 -4 1 2 8 14 15 27 15 27 14 27 -16 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2815 499 c-22 -10 -29 -16 -15 -13 28 7 80 33 65 33 -5 0 -28 -9 -50 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3478 513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3588 499 c12 -14 19 -29 15 -32 -3 -4 -1 -7 5 -7 20 0 14 15 -15 41 l-28 24 23 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2738 473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3065 470 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2688 463 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3508 453 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3290 446 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3351 432 c-1 -8 -6 -10 -13 -6 -8 5 -7 1 2 -10 15 -19 26 -7 17 17 -4 9 -6 9 -6 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2505d56682dfcbf97f21d35369ed2470.svg";
export { ForwardRef as ReactComponent };